<style>
.notice {
    background-color: rgb(202, 234, 255);
    color: rgb(9, 157, 255);
    border-radius: 10px;
    padding: 10px;
    margin-bottom: 30px;
    margin-top: 0px;
    display: inline-block;
}

</style>

<script>
import LoginView from './LoginView.svelte';

export let afterFunc

</script>
<div class="notice">
    Almost Done! Sign Up To Finish Posting Your Item To The Map!
</div>
<LoginView {afterFunc}></LoginView>